import {
	CARGO_ROW_SOURCE,
	CARGO_TYPE,
	getCapacityCargoTypeLabel,
	OTHER_FAMILY_CARGO_TYPES,
	TCargoRow
} from '@types';
import { getCargoTypeFromCargoTypeId } from './getCargoTypeFromCargoTypeId';

/* EOS rows keep pallet spaces and Bundle/Skid/Other quantities in the same qty field, which the carrier API
   sends on as pallet_space_quantity. */
const SOURCE_FIELDS = {
	[CARGO_ROW_SOURCE.EOS]: {
		spaces: 'qty', quantity: 'qty', pallets: 'pallet_qty', weight: 'total_weight', description: 'freight_detail', length: 'length', width: 'width', height: 'height'
	},
	[CARGO_ROW_SOURCE.SHIP_API]: {
		spaces: 'pallet_space_quantity', quantity: 'other_quantity', pallets: 'pallet_quantity', weight: 'total_weight_kg', description: 'freight_details', length: 'length_cm', width: 'width_cm', height: 'height_cm'
	},
	[CARGO_ROW_SOURCE.CARRIER_API]: {
		spaces: 'pallet_space_quantity', quantity: 'pallet_space_quantity', pallets: 'pallet_quantity', weight: 'weight', description: 'freight_detail', length: 'length', width: 'width', height: 'height'
	},
};

/* Reads a shipment's raw cargos into one TCargoRow each, so the cargo descriptions, totals and breakdowns
   never deal with any API's field names. EOS and carrier API rows are typed by their cargo_type_id
   (fallbackCargoTypeId for rows without one), Ship API rows by their cargo_type. */
export const getCargoRows = (
	// could be typed once APP-9069 is done
	cargos: any[],
	options: { source?: CARGO_ROW_SOURCE; fallbackCargoTypeId?: number } = {}
): TCargoRow[] => {
	const { source = CARGO_ROW_SOURCE.EOS, fallbackCargoTypeId } = options;
	const fields = SOURCE_FIELDS[source];
	return cargos.map((cargo) => {
		const type = (source === CARGO_ROW_SOURCE.SHIP_API
			? cargo?.cargo_type
			: getCargoTypeFromCargoTypeId(cargo?.cargo_type_id ?? fallbackCargoTypeId)) as CARGO_TYPE;
		const isQuantityRow = OTHER_FAMILY_CARGO_TYPES.includes(type);
		const qty = Number(cargo?.[isQuantityRow ? fields.quantity : fields.spaces]) || 0;
		// A row booked without a pallet count shows what it was booked by as its items.
		const items = isQuantityRow ? qty : (Number(cargo?.[fields.pallets]) || qty);
		const cubic = parseFloat(String(cargo?.total_cubic_volume_mts ?? '').replace('m³', ''));
		return {
			type,
			typeLabel: getCapacityCargoTypeLabel(type),
			qty,
			items,
			weight: Number(cargo?.[fields.weight]) || 0,
			cubic: isNaN(cubic) ? 0 : cubic,
			description: cargo?.[fields.description] || undefined,
			length: Number(cargo?.[fields.length]) || undefined,
			width: Number(cargo?.[fields.width]) || undefined,
			height: Number(cargo?.[fields.height]) || undefined,
		};
	});
};
